import { Outlet } from "react-router-dom";
import background from "@/assets/background.png";
import styles from "./index.module.less";

function AuthLayout() {
  const backgroundStyle = {
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };
  return (
    <div className={styles.authLayout} style={backgroundStyle}>
      <Outlet />
    </div>
  );
}

export default AuthLayout;
